import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import { ReconciliationPage } from "@/features/K1Dashboard/reconciliation/ui/ReconciliationPage";

export default function K1PositionsIssuersReconciliation() {
  useEffect(() => {
    setDocumentTitle("Quantilia | K1 Reconciliation");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <ReconciliationPage />
      </main>
    </K1DashboardProvider>
  );
}
